import { Injectable } from '@angular/core';
import { Params } from '@angular/router';

@Injectable()
export class LocaleService {
    static LOCALES = {"english": "en_US", "spanish": "es_ES"};  
    private localeStr: string;
    private ENGLISH = "ENGLISH";
    private SPANISH = "SPANISH";
    
    private readonly LOCALE_COOKIE : string = "fafsa_locale";
    
    constructor() {
        this.setLocaleFromParams();
    };
    
    getLocaleStr() {
        return LocaleService.LOCALES.english;
    }
    
    getLanguage() : string {
    	if(this.localeStr == LocaleService.LOCALES.spanish) {
            window.document.documentElement.setAttribute('lang', 'es');
    		return this.SPANISH;
    	} else {
            window.document.documentElement.setAttribute('lang', 'en');
    		return this.ENGLISH;
    	}
    }

    /**
     * Returns the language portion of the local
     * @return language
     */
    public getLocaleLanguage(): string {
        if(this.localeStr == LocaleService.LOCALES.spanish) {
            return 'es';
        } else {
            return 'en';
        }
    }

    public storeLocale() {
    }
    
    public restoreLocale() {
    }
    
    public isSpanish(): boolean {
        const locale = this.getLocaleStr();
        return locale == LocaleService.LOCALES.spanish;
    }
    
    private setLocaleStr(locale: string) {
    	if(locale == LocaleService.LOCALES.spanish ||
            locale == this.SPANISH) {
            this.localeStr = LocaleService.LOCALES.spanish;
        } else {
            this.localeStr = LocaleService.LOCALES.english;
        }
    }
    
    private setLocaleFromParams() : void {
    }
}
